function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 3h4v1h6v2H4V4h6V3zm9 4H5v13a1 1 0 001 1h12a1 1 0 001-1V7zM9 10H8v7h1v-7zm3.5 0h-1v7h1v-7zm2.5 0h1v7h-1v-7z",
  fill: "currentColor"
});

function SvgDelete(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAzSDE0VjRIMjBWNkg0VjRIMTBWM1pNMTkgN0g1VjIwQzUgMjAuNTUyMyA1LjQ0NzcyIDIxIDYgMjFIMThDMTguNTUyMyAyMSAxOSAyMC41NTIzIDE5IDIwVjdaTTkgMTBIOFYxN0g5VjEwWk0xMi41IDEwSDExLjVWMTdIMTIuNVYxMFpNMTUgMTBIMTZWMTdIMTVWMTBaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };